import { render, staticRenderFns } from "./ModalGroupOrder.vue?vue&type=template&id=36261ac0&lang=pug&"
import script from "./ModalGroupOrder.vue?vue&type=script&lang=js&"
export * from "./ModalGroupOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports